import React from "react";
import { Row, Col } from "react-bootstrap";
import { Card, Typography, Button, Avatar, Space } from "antd";
import { ShoppingCartOutlined, StarFilled } from "@ant-design/icons";

const { Title, Text } = Typography;

export type ProductCardProps = {
  name: string;
  price: number;
  unitLabel?: string;
  rating: number;
  vendorName: string;
  vendorInitials?: string;
  imageUrl: string;
  currencySymbol?: string;
  onAddToCart?: () => void;

  /** Optional: wrap it in a bootstrap grid row/col automatically */
  useBootstrapGrid?: boolean;
};

const ProductCardInner: React.FC<ProductCardProps> = ({
  name,
  price,
  unitLabel = "(1 Kg)",
  rating,
  vendorName,
  vendorInitials,
  imageUrl,
  currencySymbol = "₦",
  onAddToCart,
}) => {
  const initials =
    vendorInitials ??
    vendorName
      .split(" ")
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase())
      .join("");

  return (
    <div className="product-card-wrapper">
      <Card className="product-card" bordered={false} bodyStyle={{ padding: 18 }}>
        <div className="product-image-wrapper">
          <img src={imageUrl} alt={name} className="product-image" />

          <div className="product-rating">
            <StarFilled className="product-star" />
            <span>{rating.toFixed(1)}</span>
          </div>
        </div>

        <div className="product-content">
          <Title level={3} className="product-title">
            {name}
          </Title>

          <div className="product-price-row">
            <Text className="product-currency">{currencySymbol}</Text>
            <Text className="product-price">{price}</Text>
            <Text className="product-unit"> {unitLabel}</Text>
          </div>

          <Space className="product-vendor-row" align="center" size={10}>
            <Avatar className="product-vendor-avatar">{initials}</Avatar>
            <Text className="product-vendor-name">{vendorName}</Text>
          </Space>

          <Button
            type="primary"
            icon={<ShoppingCartOutlined />}
            block
            size="large"
            className="product-add-btn"
            onClick={onAddToCart}
          >
            Add To Cart
          </Button>
        </div>
      </Card>
    </div>
  );
};

const ProductCard: React.FC<ProductCardProps> = (props) => {
  if (!props.useBootstrapGrid) return <ProductCardInner {...props} />;

  // Responsive bootstrap layout wrapper (centered)
  return (
    <Row className="justify-content-center g-3">
      <Col xs={12} sm={10} md={8} lg={5} xl={4}>
        <ProductCardInner {...props} />
      </Col>
    </Row>
  );
};

export default ProductCard;